/*
* This class is update library almost all
*
* */
import React from 'react';
import {Greetings} from "aws-amplify-react";
import {I18n} from "aws-amplify";
import AmplifyTheme from 'aws-amplify-react/dist/Amplify-UI/Amplify-UI-Theme';
import {MessageComponent} from "../Components/MessageComponents";
import {GeneLifeDict} from "../translate/GeneLife";
import {fetchSession, fetchSessionByOauth, moveToECCWithCookie} from "../Logics/session";
import {fetchSocialProviderInfo} from '../Logics/social_provider'
import * as qs from "qs";
import fetchOIDCInfo, {connectOIDCInfo, oidcUserlogout} from "../Logics/oauth";
import {OidcErrComponets} from "../Components/oidcErrComponents";

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export default class Message extends Greetings {
    constructor(props) {
        super(props);
        this.state = {
            transferErrDisplay: false,
            timeoutErrDisplay: false,
            startOauth: false,
            oauthErrDisplay: false,
            socialProviderInputFinish: false,
            mode: false,
        };
        this._validAuthStates = ['NewPassSendMessage', 'CompChangePass','CompSignUp', 'OauthErr' ];
    }

    componentDidMount() {
        // 一番最初にすでにsignedIn状態の場合、そのままメッセージ出さずにログイン画面に向かわせる
        const path = window.location.pathname;
        let errDisplayFunc = () => {
            this.setState({
                timeoutErrDisplay: true,
                transferErrDisplay: false
            })
        };
        // すでにoauth signInの場合、数秒(5秒たったら)ローディング解除しメッセージ表示
        if (path === '/oauth') {
            errDisplayFunc = () => {
                this.setState({
                    timeoutErrDisplay: false,
                    transferErrDisplay: true
                })
            };
        }
        if (path !== '/') {
            // oauth処理時はローディングを操作
            setTimeout(() => {
                errDisplayFunc.call(this);
            }, 5000);

        } else {
            // 通常時はローディングを表示させない
            setTimeout(() => {
                errDisplayFunc.call(this);
            }, 0);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.authState !== this.props.authState && prevProps.authState === 'OauthErr') {
            this.setState({oauthErrDisplay: true});
        }
        // ログイン処理中の、ローディング時のタイムアウト画面を表示させる処理
        if (prevProps.authState !== this.props.authState) {
            this.setState({transferErrDisplay: false, timeoutErrDisplay: false});
            if (prevProps.authState  === 'signIn' && this.props.authState === 'signedIn') {
                this.setState({timeoutErrDisplay: true});
            }
            setTimeout(() => {
                this.setState({transferErrDisplay: true, timeoutErrDisplay: false})
            }, 30000);
        }
    }

    render() {
        const theme = this.props.theme || AmplifyTheme;
        const authState = this.props.authState || this.state.authState;
        if (window.location.pathname === "/prepare_oauth" && !this.state.startOauth) {
            const params = qs.parse(window.location.search.substr(1));
            const code = params["code"];
            this.changeState("loading");
            fetchOIDCInfo(code)
                .then(res => {
                    this.changeState("signUp", Object.assign(res, {action_type: 'connected_oauth'}));
                }).catch(err => {
                    window.history.replaceState('','','/');
                    this.changeState("OauthErr");
                })
            if (authState === 'loading') {
                this.setState({startOauth: true})
            }
        }

        else if (window.location.pathname === "/connect_oauth" && !this.state.startOauth) {
            const params = qs.parse(window.location.search.substr(1));
            const code = params["code"];
            this.changeState("loading");
            connectOIDCInfo(code)
                .then(res => {
                    window.history.replaceState('','','/change_user_info');
                    this.changeState("ChangeUserInfo", {action_type: 'connect_oauth'});
                }).catch(err => {
                window.history.replaceState('','','/');
                this.changeState("OauthErr");
            })
            if (authState === 'loading') {
                this.setState({startOauth: true})
            }
        }

        else if (window.location.pathname === "/oauth" && !this.state.startOauth) {
            const params = qs.parse(window.location.search.substr(1));
            const code = params["code"];
            this.setState({startOauth: true})
            fetchSessionByOauth(code)
                .then((res) => {
                    // oidcのログイン時にユーザ情報変更画面に遷移できるようにlocalStorageにフラグを保存
                    localStorage.setItem("change_user_info", true);
                    moveToECCWithCookie(res.gene);
                })
                .catch(err => {
                    window.history.replaceState('','','/');
                    this.changeState("OauthErr");
                });
        }


        if (window.location.pathname.match(RegExp("/sign_up[/]?$"))) {
            const params = qs.parse(window.location.search.substr(1));
            const key = params["key"];
            const mode = params["mode"];
            if (!this.state.mode) {
                this.setState({mode: "wgs"});
            }
            if (key && !this.state.startOauth) {
                this.changeState("loading");
                this.setState({startOauth: true})
                fetchSocialProviderInfo(key).then( res => {
                    this.setState({socialProviderInputFinish: true})
                    this.changeState("signUp", Object.assign(res, {action_type: 'connected_social_provider'}));
                }).catch(e => {
                    window.history.replaceState('','','/sign_up');
                    this.changeState("signUp", {action_type: 'unconnected_oauth'});
                });
            } else if (!key) {
                this.changeState("signUp", {action_type: 'unconnected_oauth', mode: mode});
            }
        }
        if (window.location.pathname === "/forget_password") {
            const params = qs.parse(window.location.search.substr(1));
            const {email,code} = params;
            this.changeState("forgotPassword",{username: email, code});
        }
        if (window.location.pathname === "/confirm_sign_up") {
            const params = qs.parse(window.location.search.substr(1));
            const {email,code} = params;
            this.changeState("confirmSignUp",{username: email, code, isInitialMessage: true});
        }
        if (window.location.pathname === "/check_account") {
            this.changeState("checkEccAccount");
        }
        // 特定のpassでアクセスがあった場合遷移させる
        if (window.location.pathname === "/logout") {
            this.changeState("signOut");
        }
        if (window.location.pathname === "/wgs") {
            this.changeState("wgs");
        }
        if (window.location.pathname === "/wgs/consent") {
            this.changeState("wgsConsent");
        }
        // 特定のpassでアクセスがあった場合遷移させる
        if (window.location.pathname === "/change_email" &&
            (localStorage["amplify-authenticator-authState"] === "signedIn"|| localStorage["amplify-authenticator-authState"] === "ChangeEmail") ) {
            this.changeState("ChangeEmail");
        }

        if (window.location.pathname === "/change_password" &&
            (localStorage["amplify-authenticator-authState"] === "signedIn" || localStorage["amplify-authenticator-authState"] === "forgotPassword")) {
            this.changeState("forgotPassword");
        }

        if (window.location.pathname === "/change_user_info" &&
            (localStorage["amplify-authenticator-authState"] === "signedIn" || localStorage["amplify-authenticator-authState"] === "ChangeUserInfo" ||
                localStorage["amplify-authenticator-authState"] === "oauthSignedIn")) {
            this.changeState("ChangeUserInfo");
        }

        if (authState === "NewPassSendMessage") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')} title={I18n.get("Send Mail")}
                                  hint={I18n.get("Please check email")} linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "CompChangePass") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')}
                                  title={I18n.get("Password Update Complete")} hint={I18n.get("Please login again")}
                                  linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "CompChangeEmail") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')}
                                  title={I18n.get("Email Update Complete")} hint={I18n.get("Please login again")}
                                  linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "CompChangeUserInfo") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => {
                    this.changeState('loading');
                    fetchSession().then((res) => {
                        moveToECCWithCookie(res.gene);
                    }).catch(e => console.log(e));
                }}
                                  title={I18n.get("User Info Update Complete")} hint={I18n.get('Back to MyPage Message')}
                                  linkName={I18n.get('Back to MyPage')}/>
            );
        } else if (authState === "CompConfirmSignUp") {
            if (this.state.mode === "wgs") {
                // window.location.replace('./?mode=wgs');
                return (
                    <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn', {mode: this.state.mode})}
                                      title={I18n.get("WGS Confirm SignUp Complete")} hint={I18n.get("WGS Please login again")}
                                      linkName={I18n.get("Back to Sign In Toregist")}/>
                );
            }
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn', {mode: this.state.mode})}
                                  title={I18n.get("Confirm SignUp Complete")} hint={I18n.get("Please login again")}
                                  linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "CompOIDCSignUp") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => {
                            oidcUserlogout().then(() => this.changeState('signIn')).catch(() => this.changeState('signIn'));
                            window.history.replaceState('','','/');

                        }
                    }
                  title={I18n.get("Confirm SignUp Complete")} hint={I18n.get("Please login again")}
                  linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "sameEmail") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')}
                                  title={I18n.get("Confrim account completed")} hint={I18n.get("Move to Login")}
                                  linkName={I18n.get("Back to Sign In")}/>
            );
        } else if (authState === "updateEmail") {
            return (
                <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')}
                                  title={I18n.get("Change Email complete")} hint={I18n.get("Back and login via new Email")}
                                  linkName={I18n.get("Go to Login")}/>
            );
        } else if (authState === "OauthErr" || this.state.oauthErrDisplay) {
            this.changeState("oauthSignIn");
            return (
                <OidcErrComponets theme={this.props.theme} onClick={() => {
                    this.setState({oauthErrDisplay: false})
                    window.history.replaceState('', '', '/sign_up');
                    this.changeState('signUp');

                }} onClick1={() => {
                    oidcUserlogout()
                    .then(() => {
                            this.setState({oauthErrDisplay: false})
                            this.changeState('signIn', {display_screen: true});
                        }
                    ).catch(() => {
                            this.setState({oauthErrDisplay: false})
                            this.changeState('signIn', {display_screen: true});
                        }
                    )
                    window.history.replaceState('','','/');
                }}/>

            )

        } else if (authState === "signedIn" || authState === "loading") {
            if (this.state.timeoutErrDisplay) {
                    this.changeState('signIn');
                    return null;
            } else if(this.state.transferErrDisplay) {
                return (
                    <MessageComponent theme={theme} changeStateFunc={() => this.changeState('signIn')} title={I18n.get("Transfer msg")}
                                      hint={I18n.get("Transfer info_msg")} linkName={I18n.get("Back to Sign In on not transfering mypage")}/>
                )
            } else {
                return null;
            }
        } else {
            const params = qs.parse(window.location.search.substr(1));
            const mode = params["mode"];
            if (!this.state.mode) {
                this.setState({mode: "wgs"});
            }
            if (window.location.pathname === "/change_user_info" && localStorage["change_user_info"]) {
                // oidcのユーザ情報変更画面に遷移前に、oidc時に格納したlocalStorageにフラグがあれば遷移可能とする
                this.changeState("ChangeUserInfo");

            } else if (window.location.pathname === "/prepare_oauth" || window.location.pathname === "/oauth" || window.location.pathname === "/connect_oauth") {
                this.changeState('loading');
            } else if (window.location.pathname.match(RegExp("/sign_up[/]?$"))) {
                // アプリからToken付きでWeb画面で遷移してきた際に、ログイン画面を表示させずにローディングを表示させておく処理
                const params = qs.parse(window.location.search.substr(1));
                const key = params["key"];
                if (key && !this.state.socialProviderInputFinish) {
                    this.changeState('loading');
                } else {
                    return null;
                }
            }
            return null;
        }
    }
}